<template>
  <div class="headerTips">
    <h1>{{ $t('tips.label.listTips.title') }}</h1>

    <v-data-table
      :headers="headers"
      :items="tips"
      :header-props="{ class: 'red-header' }"
      :search="searchTerm"
      :no-data-text="$t('chart.label.notData') || 'No hay datos disponibles'"
      :footer-props="{ 'items-per-page-text': $t('label.rowsPerPage.title') }"
    >
      <!-- Sección superior de la tabla -->
      <template v-slot:top>
        <div style="margin-bottom: 50px">
          <div class="row justify-space-between mx-auto">
            <v-text-field
              :label="$t('label.search.title')"
              :placeholder="$t('label.search.text')"
              append-icon="mdi-magnify"
              dense
              outlined
              class="col-md-5"
              @input="search"
            ></v-text-field>

            <div class="btn">
              <addTips />
            </div>
          </div>
        </div>
      </template>

      <template v-slot:[`item.title`]="{ item }">
        <span class="custom-font">{{ item.title }}</span>
      </template>

      <template v-slot:[`item.description`]="{ item }">
        <span class="custom-font">{{ item.description }}</span>
      </template>

      <template v-slot:[`item.happinessCategoryTipsName`]="{ item }">
        <span class="custom-font">{{ item.happinessCategoryTipsName }}</span>
      </template>

      <template v-slot:[`item.status`]="{ item }">
        <span class="custom-font">{{ item.status ? $t('novelties.label.status.option1') : $t('novelties.label.status.option2') }}</span>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <div class="actions">
          <detailTips
            :tipsProps="item"
            style="margin-left: 1vh"
            ><v-btn icon x-large dark text>
              <v-icon class="mt-2" color="primary">mdi-border-color</v-icon>
            </v-btn>
          </detailTips>

          <v-btn
            class="btnDetails"
            icon
            x-large
            dark
            text
            @click="confirmDeleteTips(item.happinessCategoryTipsId)"
            style="background-color: transparent; margin-left: 1vh"
          >
            <v-icon color="primary">mdi-delete</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>

    <v-dialog
      v-model="dialog"
      transition="dialog-bottom-transition"
      max-width="600"
      persistent
    >
      <v-card class="container justify-content-between align-items-center">
        <button class="close-button" @click="closeDialog">
          <span class="small-x">X</span>
        </button>
        <v-col cols="12" md="12" sm="6">
          <img
            src="https://ibliss-icons-prod.s3.us-east-1.amazonaws.com/marca_empresarial/image-welcomeDefault.png"
            alt="Imagen de bienvenida"
            class="custom-img"
          />
        </v-col>
        <h2 class="custom-title">{{ $t('tips.label.delete.title') }}</h2>

        <v-row dense>
          <v-col cols="12" md="12" sm="12">
            <v-textarea
              color="secondary"
              :label="'*'+$t('label.observation.title')" 
              :placeholder="$t('label.observation.text')"
              v-model="formData.observation"
              :counter="100"
              :maxlength="100"
              required
              :rules="messageRules"
              outlined
              @input="changeObservation"
            ></v-textarea>
          </v-col>
          <v-btn
            large
            block
            rounded
            :color="isSubmitting ? 'primary' : 'grey'"
            class="mb-4 custom-btn"
            style="color: white; border-radius: 50px"
            :disabled="!isSubmitting"
            @click="deleteTips()"
          >
            {{ $t('button.delete') }}
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import addTips from "@/views/tips-categories/pages/add_tips/add_tips_page.vue";
import detailTips from "@/views/tips-categories/pages/detail_tips/detail_tips_page.vue";
import EventBus from "@/utils/event_bus.js";
import { mapActions, mapGetters } from "vuex";
import i18n from '@/plugins/i18n';
import Swal from "sweetalert2";

import {
  TIPS_M,
  GET_TIPS,
  ACTION_GET_TIPS,
  ACTION_DELETE_TIPS,
} from "@/views/tips-categories/store/types/types.js";

export default {
  name: "listTipsComponent",
  components: {
    addTips,
    detailTips,
  },

  data() {
    return {
      dialog: false,
      isSubmitting: false,
      tipId: null,
      searchTerm: "",
      messageRules: [(v) => !!v || this.$t('label.observation.required')],
      formData: {},
    };
  },

  async mounted() {
    await this.getActionTips();

    EventBus.$on("reload-tips", async () => {
      await this.reloadTips();
    });

    EventBus.$on("reload-update-tips", async () => {
      await this.reloadTips();
    });
  },

  methods: {
    ...mapActions({
      getActionTips: `${TIPS_M}${ACTION_GET_TIPS}`,
      deleteActionTips: `${TIPS_M}${ACTION_DELETE_TIPS}`,
    }),

    async reloadTips() {
      await this.getActionTips();
    },

    search() {
      this.searchTerm = event.target.value;
    },

    closeDialog() {
      EventBus.$emit("close-dialog");
      this.dialog = false;
      window.location.reload();
    },

    async confirmDeleteTips(tipId) {
      this.dialog = true;
      this.formData.tipId = tipId;
    },

    changeObservation() {
      if (this.formData.observation.trim()) {
        this.isSubmitting = true;
      } else {
        this.isSubmitting = false;
      }
    },

    async deleteTips() {
      Swal.fire({
        title: i18n.t('label.delete.title'),
        text: i18n.t('label.delete.text'),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: i18n.t('button.delete.accept'),
        cancelButtonText: i18n.t('button.delete.cancel'),
        confirmButtonColor: "#6E17A5",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await this.deleteActionTips(this.formData.tipId);
            await Swal.fire({
              position: "top-end",
              icon: "success",
              title: i18n.t('tips.actionDeleteTips.success'),
              showConfirmButton: false,
              timer: 2500,
            });
            this.closeDialog();
          } catch (error) {
            console.error("Error al eliminar:", error);
            Swal.fire({
              icon: "error",
              text: i18n.t('label.errorServiceDelete'),
            });
          }
        } else {
          await Swal.fire({
            position: "top-end",
            icon: "info",
            title: i18n.t('label.delete.cancel'),
            showConfirmButton: false,
            timer: 2500,
          });
          this.closeDialog();
        }
      });
    },
  },

  computed: {
    ...mapGetters({
      tips: [`${TIPS_M}${GET_TIPS}`],
    }),

    headers() {
      return [
        {
          text: this.$t('tips.label.table.categoryName'),
          value: "happinessCategoryTipsName",
          align: "center",
          sortable: false,
          class:
            "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: this.$t('tips.label.table.status'),
          value: "status",
          align: "center",
          sortable: false,
          class:
            "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          value: "action",
          sortable: false,
          align: "center",
        },
      ];
    },
  },
};
</script>

<style lang="css" scoped>
.headerTips h1 {
  margin-bottom: 30px;
}

.headerTips {
  display: flex;
  gap: 40px;
  flex-direction: column;
  margin-top: 20px;
  margin-left: 20px;
}

.actions v-icon {
  font-size: 24px;
}
.custom-font {
  font-size: 20px;
}

body {
  font-family: "Nunito Sans", sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Amsi Pro", sans-serif;
  color: #2d0049;
  font-weight: normal;
}

.btnDetails .v-icon {
  color: #6e17a5;
  margin-bottom: 19px;
}

.actions {
  display: flex;
}

img {
  width: 3rem;
  height: 3rem;
}

.custom-img {
  width: 170px;
  height: auto;
  display: block;
  margin: 0 auto;
}

.custom-title {
  color: #6e17a5;
  justify-items: center;
}

.close-button {
  position: absolute;
  top: 5px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
}

.small-x {
  font-size: smaller;
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 3vh;
  color: #6e17a5;
}

.custom-btn {
  border-radius: 50px;
  padding: 12px;
}

@media screen and (max-width: 414px) {
  h1 {
    font-size: 3vh;
    margin-left: 2vh;
  }
  .custom-font {
    font-size: 13px;
  }
  img {
    margin-top: 18px;
    margin-bottom: auto;
    width: 3rem;
    height: 3rem;
  }
}

@media screen and (min-width: 414px) {
  h1 {
    font-size: 4vh;
    margin-left: 2vh;
  }
}

@media screen and (max-width: 280px) {
  h1 {
    font-size: 3vh;
    margin-left: 2vh;
  }
  h2 {
    font-size: 2vh;
  }
  .custom-font {
    font-size: 13px;
  }
  img {
    margin-top: 20px;
    margin-bottom: 10px;
    width: 3rem;
    height: 3rem;
  }
}
</style>
